"use strict";

exports.__esModule = true;
exports.DataItemChartFields = DataItemChartFields;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Translator = require("../../Core/Translator");
var _common = require("../../Device/common");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _constants = require("../../Recharts/constants");
var _MultiFieldSelector = require("../../Recharts/Fields/MultiFieldSelector/MultiFieldSelector");
var _XAxisFields = require("../../Recharts/Fields/XAxisFields");
var _YAxisDomainFields = require("../../Recharts/Fields/YAxisDomainFields");
var _YAxisFields = require("../../Recharts/Fields/YAxisFields");
var _ScatterPlotChartRadiusPicker = require("../MeasureChart/Fields/ScatterPlotChartRadiusPicker");
var _ChartTypeSelector = require("./ChartTypeSelector");
var _constants2 = require("./constants");
var _InterpolationTypeSelector = require("./InterpolationTypeSelector");
var _constants3 = require("../../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "DataItemChartFields__AxisControls",
  componentId: "sc-gbv9ge-0"
})(["display:flex;label{flex:1;}"]);
function DataItemChartFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var _element$props = element.props,
    dataItemSource = _element$props.dataItemSource,
    dataItemIndex = _element$props.dataItemIndex,
    chartType = _element$props.chartType,
    scatterPlotRadius = _element$props.scatterPlotRadius,
    hideXAxis = _element$props.hideXAxis,
    hideYAxis = _element$props.hideYAxis,
    hideLabel = _element$props.hideLabel,
    _element$props$showCh = _element$props.showChartTooltip,
    showChartTooltip = _element$props$showCh === void 0 ? true : _element$props$showCh,
    _element$props$showLe = _element$props.showLegend,
    showLegend = _element$props$showLe === void 0 ? true : _element$props$showLe,
    dataRange = _element$props.dataRange;
  return /*#__PURE__*/_react["default"].createElement(_DeviceListContext.DeviceListContext.Consumer, null, function (devices) {
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("DataItem.source.label", "Data Item Source")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement("select", {
        "data-testid": "dataitemsource-selector",
        value: dataItemSource || "mtc",
        onChange: function onChange(e) {
          return elementEditor.setProps(path, {
            dataItemSource: e.target.value,
            mtcDataItems: []
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "realtime"
      }, translate("DataItem.source.realtime.label", "Realtime Data Item")), /*#__PURE__*/_react["default"].createElement("option", {
        value: "historical"
      }, translate("DataItem.source.historical.label", "Historical Data Item")), /*#__PURE__*/_react["default"].createElement("option", {
        value: "mtc"
      }, translate("DataItem.source.mtc.label", "MTC Data Item"))))), dataItemSource !== "realtime" && /*#__PURE__*/_react["default"].createElement(_ChartTypeSelector.ChartTypeSelector, props), chartType === _constants.LINE_CHART || dataItemSource === "realtime" ? /*#__PURE__*/_react["default"].createElement(_InterpolationTypeSelector.InterpolationTypeSelector, props) : null, chartType === _constants.SCATTER_CHART && dataItemSource !== "realtime" && /*#__PURE__*/_react["default"].createElement(_ScatterPlotChartRadiusPicker.ScatterPlotChartRadiusPicker, {
        radius: scatterPlotRadius || 5,
        handleRadiusChange: function handleRadiusChange(radius) {
          elementEditor.setProp(path, "scatterPlotRadius", radius);
        }
      }), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Consumer, null, function (layoutSettings) {
        return layoutSettings.selection.allowReportingPeriod && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: translate("DataItem.dataRange.label", "Data Range"),
          helperText: translate("DataItem.dataRange.helperText", "The data range to show in this chart.")
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _core.Classes.HTML_SELECT
        }, /*#__PURE__*/_react["default"].createElement("select", {
          value: dataRange || "",
          onChange: function onChange(e) {
            return elementEditor.setProp(path, "dataRange", e.target.value || undefined);
          }
        }, /*#__PURE__*/_react["default"].createElement("option", {
          value: ""
        }, translate("DataItem.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
          value: "SELECTION"
        }, translate("DataItem.dataRange.selection.label", "Selection")))));
      }), /*#__PURE__*/_react["default"].createElement(_XAxisFields.XAxisFields, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
        "data-testid": "hide-x-axis-checkbox",
        label: translate("DataItem.axes.hideXAxis.label", "Hide X Axis"),
        checked: hideXAxis || false,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "hideXAxis", e.target.checked);
        }
      })), /*#__PURE__*/_react["default"].createElement(_YAxisFields.YAxisFields, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("DataItem.dataItem.label", "Data Item")
      }, dataItemSource === "realtime" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement("select", {
        value: dataItemIndex,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "dataItemIndex", e.target.value);
        }
      }, _constants2.dataItemIndexArray.map(function (_ref2) {
        var dataItemIndex = _ref2.dataItemIndex,
          translationKey = _ref2.translationKey,
          dataItemLabel = _ref2.dataItemLabel;
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: dataItemIndex,
          value: dataItemIndex
        }, translate(translationKey, dataItemLabel));
      }))) : dataItemSource === "historical" ? /*#__PURE__*/_react["default"].createElement(_MultiFieldSelector.MultiFieldSelector, {
        getKey: function getKey(input) {
          return String(input.dataItemIndex);
        },
        renderItemText: function renderItemText(input) {
          return input.dataItemLabel;
        },
        itemPredicate: function itemPredicate(query, _ref3) {
          var dataItemLabel = _ref3.dataItemLabel;
          var q = query.toLowerCase();
          return dataItemLabel.toLowerCase().indexOf(q) !== -1;
        },
        selectedItems: element.props.historicalDataItems,
        onChange: function onChange(selectedValues) {
          return elementEditor.setProp(path, "historicalDataItems", selectedValues);
        },
        items: _constants2.dataItemIndexArray
      }) : /*#__PURE__*/_react["default"].createElement(_MultiFieldSelector.MultiFieldSelector, {
        getKey: function getKey(input) {
          return input.dataItemName;
        },
        renderItemText: function renderItemText(input) {
          return input.dataItemName;
        },
        itemPredicate: function itemPredicate(query, _ref4) {
          var dataItemName = _ref4.dataItemName;
          var q = query.toLowerCase();
          return dataItemName.toLowerCase().indexOf(q) !== -1;
        },
        renderItemLabel: function renderItemLabel(input) {
          return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "DeviceDataItemStatsSelector.itemLabel",
            defaultMessage: "{deviceCount, number} {deviceCount, plural, one {device} other {devices}}",
            values: input
          });
        },
        selectedItems: element.props.mtcDataItems,
        onChange: function onChange(selectedValues) {
          return elementEditor.setProp(path, "mtcDataItems", selectedValues);
        },
        items: (0, _common.getDeviceDataItemStats)(devices, [_constants3.CATEGORY_SAMPLE])
      })), /*#__PURE__*/_react["default"].createElement(_YAxisDomainFields.YAxisDomainFields, props), /*#__PURE__*/_react["default"].createElement(AxisControls, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
        "data-testid": "hide-y-axis-checkbox",
        label: translate("DataItem.axis.hideYAxis.label", "Hide Y Axis"),
        checked: hideYAxis || false,
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "hideYAxis", e.target.checked);
        }
      }), dataItemSource === "realtime" && /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
        "data-testid": "hide-label-axis-checkbox",
        checked: hideLabel || false,
        label: translate("DataItem.hideLabel.label", "Hide Label"),
        onChange: function onChange() {
          return elementEditor.setProp(path, "hideLabel", !hideLabel);
        }
      }))), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
        "data-testid": "show-legend-checkbox",
        label: translate("DataItem.showLegend.label", "Show Legend"),
        checked: showLegend,
        onChange: function onChange() {
          elementEditor.setProp(path, "showLegend", !showLegend);
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
        "data-testid": "show-legend-checkbox",
        label: translate("DataItem.showChartTooltip.label", "Show Chart Tooltip"),
        checked: showChartTooltip,
        onChange: function onChange() {
          elementEditor.setProp(path, "showChartTooltip", !showChartTooltip);
        }
      }));
    });
  });
}